import { Component, inject } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { ModalService } from '@shared/services/modal.service';

@Component({
  selector: 'lib-ff-template',
  styleUrls: ['./template.component.scss'],
  templateUrl: './template.component.html',
  imports: [],
})
export class TemplateComponent extends FieldType {
  private readonly modalService = inject(ModalService);

  public openTooltip() {
    this.modalService
      .open({
        title: this.props.label !== undefined ? this.props.label : this.props.addText,
        message: this.props.tooltip,
      })
      .then(
        () => null,
        () => null,
      );
  }

  public close() {
    this.modalService.close();
  }
}
